import { render, staticRenderFns } from "./ExtensionPage.vue?vue&type=template&id=7195bcf3&scoped=true"
import script from "./ExtensionPage.vue?vue&type=script&lang=js"
export * from "./ExtensionPage.vue?vue&type=script&lang=js"
import style0 from "./ExtensionPage.vue?vue&type=style&index=0&id=7195bcf3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7195bcf3",
  null
  
)

export default component.exports